import { ANCHORED_MENU_PROPS } from 'utils/muiSelectProps';

const theme = {
  typography: {
    fontFamily: "'Source Sans Pro', sans-serif",
  },
  palette: {
    primary: {
      main: '#4E7BCD',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#29b6f6',
    },
    text: {
      primary: '#242546',
      secondary: '#9e9e9e',
    },
    action: {
      disabled: '#808080',
    },
  },
  components: {
    // MUI v4's default TextField/Select variant was "standard" (underline
    // only); v5+ defaults to "outlined". Restore the old default globally
    // instead of patching every TextField/DatePicker/Select usage
    // individually. x-date-pickers' text field is a separate component
    // (MuiPickersTextField, not MuiTextField) so it needs its own entry.
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiPickersTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'standard',
        MenuProps: ANCHORED_MENU_PROPS,
      },
    },
    // MUI v4 anchored Snackbars bottom-center by default; v5+ anchors them
    // bottom-left. Restore the old default so every snackbar keeps its
    // original position without an explicit anchorOrigin at each call site.
    MuiSnackbar: {
      defaultProps: {
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: 'rgb(146, 180, 255)',
          '&.Mui-selected': {
            color: '#212566',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.greenChip': {
            backgroundColor: '#E0F1E9',
            color: '#0A522E',
          },
          '&.yellowChip': {
            backgroundColor: '#F7F2DA',
            color: '#8C7000',
          },
        },
      },
    },
  },
};

export default theme;
